import { replaceSpaces, strToFloat, trimTextContent } from 'services/utils';

export default ({ providerTableData, data }) => ({
  sender_wallet: (data.wallet && data.wallet?.wallet_number?.trim()) || '',
  currency: (data.wallet && data.wallet?.currency?.trim()) || '',
  amount: strToFloat(providerTableData?.amount?.toString() || ''),
  transaction_recipient: {
    beneficiary: {
      type: providerTableData.recipient_type.toUpperCase(),
      ...(providerTableData.recipient_type === 'Company'
        ? {
            company_name: trimTextContent(providerTableData?.company_name) || ''
          }
        : {
            first_name: trimTextContent(providerTableData?.first_name) || '',
            last_name: trimTextContent(providerTableData?.last_name) || ''
          })
    },
    requisites: providerTableData?.recipient_wallet
      ? {
          iban: replaceSpaces(providerTableData?.recipient_wallet) || '',
          bank_country: data?.bank_country?.trim(),
          // sort_code/account_number/bank_name/bic come from validateIban's response (spread into
          // `data` as ...ibanCredentials) — a GB IBAN resolves to a local sort code + account number
          // on the backend side and Convera/Faster Payments needs it alongside the IBAN itself, same
          // as bank_name/bic. Omitted entirely when absent rather than sent empty.
          ...(data?.sort_code && { sort_code: data.sort_code.trim().replace(/-/g, '') }),
          ...(data?.account_number && { account_number: data.account_number.trim() }),
          ...(data?.bank_name && { bank_name: data.bank_name.trim() }),
          ...(data?.bic && { bic: data.bic.trim() })
        }
      : {
          account_number: data?.account_number?.trim() || providerTableData?.account_number?.trim(),
          sort_code: (data?.sort_code || providerTableData?.sort_code)?.trim().replace(/-/g, ''),
          bank_country: data?.bank_country?.trim() || process.env.REACT_APP_DEFAULT_COUNTRY_CODE,
          // bank_name/bic come from validateAccountNumberAndSortCode's response (spread into `data`
          // as ...ibanCredentials, same as the SWIFT models already do) — omitted entirely when
          // absent rather than sent empty, same pattern as elsewhere in this file. The endpoint
          // doesn't return an `iban` for this pair (unlike its account-number-validate sibling used
          // by NewPaymentFormV2/Templates), so there's no equivalent field to add here.
          ...(data?.bank_name && { bank_name: data.bank_name.trim() }),
          ...(data?.bic && { bic: data.bic.trim() })
        }
  },
  payment_method: data.paymentMethod || '',
  transfer_provider: (data.wallet && data.wallet?.transfer_provider) || '',
  comment: trimTextContent(providerTableData?.comment) || '',
  documents: data.uploadedFiles ? data.uploadedFiles : [],
  ...(providerTableData.payment_purpose && { purpose: providerTableData.payment_purpose })
});
